import { render, staticRenderFns } from "./CgsbwhEdit.vue?vue&type=template&id=a14a6e70&scoped=true"
import script from "./CgsbwhEdit.vue?vue&type=script&lang=js"
export * from "./CgsbwhEdit.vue?vue&type=script&lang=js"
import style0 from "./CgsbwhEdit.vue?vue&type=style&index=0&id=a14a6e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14a6e70",
  null
  
)

export default component.exports